<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Unvan</label>
            <input type="text" class="form-control" v-model="value.Name" placeholder="Unvan" />
        </div>
        <div class="col-6 mb-1">
            <b-form-checkbox v-model="value.DriverDepartment">Sürücü</b-form-checkbox>
        </div>
        <div class="col-6 mb-1">
            <b-form-checkbox v-model="value.HRDepartment">İK</b-form-checkbox>
        </div>
        <div class="col-6 mb-1">
            <b-form-checkbox v-model="value.MRODepartment">Bakım Onarım</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Norm Kadro Sayısı</label>
            <input type="number" min="0" class="form-control" v-model="value.MaxEmployeeCount" placeholder="Norm Kadro Sayısı" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Organizasyonel Konum</label>
            <v-select-list v-model="collarStatus" label="Name" placeholder="Organizasyonel Konum" :options="collarStatuses"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Sıra</label>
            <input type="number" class="form-control" v-model="value.Order" placeholder="Sıra" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yönetsel Düzey Grubu</label>
            <v-select-list v-model="group" v-on:input="getLevels(true)" label="Name" placeholder="Yönetsel Düzey Grubu" :options="groups"/>
        </div>
        <div class="col-12">
            <label class="form-label">Yönetsel Düzey</label>
            <v-select-list v-model="level" :disabled="group == null || (levels || []).length == 0" label="Name" placeholder="Yönetsel Düzey" :options="levels"/>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data' 
import { BFormCheckbox } from 'bootstrap-vue'
import HRParametersApi from '@/api/human-resources-parameters'


export default {
    components:{
        BFormCheckbox
    },
    props: {
        value: Object,
    },
    data(){
        return {
            collarStatuses:[],
            groups:[],
            levels:[]
        }
    },
    mounted(){
        this.getGroups()
        this.getLevels(false)
        this.getCollarStatuses().then(()=>{
            if(this.value.CollarStatusId == null){
                let foundCollar = this.collarStatuses.find(m=>m.Code == "-")
                this.value.CollarStatusId = foundCollar?.Id || null
            }
        })
    },
    methods:{
        getCollarStatuses(){
            return new Promise((resolve)=>{
                SystemDataApi.CollarStatus().then(res=>{
                    this.collarStatuses = res.data.Data
                    resolve(true)
                })
            })
        },
        getGroups(){
            HRParametersApi.AdministrativeLevelGroup.List().then(res=>{
                this.groups = res.data.Data
            })
        },
        getLevels(bool){
            if(bool == true){
                this.value.AdministrativeLevelId = null
            }
            if(this.value.AdministrativeLevelGroupId){
                HRParametersApi.AdministrativeLevel.ListByGroupId(this.value.AdministrativeLevelGroupId).then(res => {
                    this.levels = res.data.Data || []
                })
            }
        }
    },
    computed:{
        collarStatus:{
            get:function(){
                return this.collarStatuses.find(m=>m.Id==this.value.CollarStatusId)
            },
            set:function(value){
                this.value.CollarStatusId = value?.Id || null
            }
        },
        group:{
            get:function(){
                return this.groups.find(b=>b.Id==this.value.AdministrativeLevelGroupId)
            },
            set:function(value){
                this.value.AdministrativeLevelGroupId = value?.Id || null
            }
        },
        level:{
            get:function(){
                return this.levels.find(b=>b.Id==this.value.AdministrativeLevelId)
            },
            set:function(value){
                this.value.AdministrativeLevelId = value?.Id || null
            }
        }
    }
}
</script>
